import { useFormikContext } from 'formik'
import { useEffect, useState } from 'react'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { QrScanner, IQrScannerProps } from '@yudiel/react-qr-scanner'

import { useQRCodeScan } from 'src/hooks'
import { ETranslationNs, IScanCreateForm } from 'src/types'
import { useScanRelationContext } from '../form-wrapper/relations-context.component'

import { useStyles } from './styles'
import { Navigation } from './navigation.component'
import { Typography } from '@mui/material'

interface IProps {
  setStep: (step: number | null) => void
}

const PERMISSION_DENIED = 'Permission denied'

export const CameraInner = ({ setStep }: IProps) => {
  const [t] = useTranslation(ETranslationNs.ScanForm)
  const [cameraDenied, setCameraDenied] = useState(false)
  const { setFieldValue } = useFormikContext<IScanCreateForm>()
  const { setRelations } = useScanRelationContext()
  const { enqueueSnackbar } = useSnackbar()
  const classes = useStyles()
  const [result, setResult] = useState<unknown | null>(null)
  const { mutate: scanQrCode, data } = useQRCodeScan()

  useEffect(() => {
    if (!result) return
    scanQrCode(result)

    const t = setTimeout(() => {
      setResult(null)
    }, 1000 * 4)
    return () => clearTimeout(t)
  }, [result, scanQrCode])

  useEffect(() => {
    if (!data) return
    setFieldValue('account_id', data.account.id)
    setFieldValue('product_id', data.product.id)
    setFieldValue('step_id', null)
    setFieldValue('impact_id', null)
    setFieldValue('impact_quantity', null)
    setRelations({
      step: null,
      impact: null,
      account: data.account,
      product: data.product,
    })
    setStep(2)
  }, [data, setFieldValue, setRelations, setStep])

  const handleDecode = (data: unknown) => {
    setResult(data)
  }

  const handleError: IQrScannerProps['onError'] = (e) => {
    if (e.message === PERMISSION_DENIED) {
      setCameraDenied(true)
      return
    }

    enqueueSnackbar(t('scan-form-qr-code-error.v'), { variant: 'error' })
  }

  return (
    <div className={classes.container}>
      <div className={classes.wrapper}>
        <QrScanner onError={handleError} onDecode={handleDecode} scanDelay={300} />
      </div>
      {cameraDenied && <Typography color="error">{t('scan-form-camera-error.v')}</Typography>}
      <Navigation />
    </div>
  )
}
